<template>
    <component :is="component" :updateItem="updateItem"></component>
</template>

<script>
import RomaFormNewActivity from "@/components/activity/RomaFormNewActivity";
export default {
    data() {
        return {
            component: RomaFormNewActivity,
            updateMode: false,
            id: this.$route.params.id
        };
    },
    computed: {
        updateItem() {
            return this.$route.params.id ? this.$route.params.id : "";
        }
    }
};
</script>

<style></style>
